import { z } from 'zod';

export const mergeUserDataRequestSchema = z.object({
  fromUserId: z.string().min(1),
  toUserId: z.string().min(1),
});

export type IMergeUserDataRequest = z.infer<typeof mergeUserDataRequestSchema>;
